import { gql } from '@apollo/client';

export const confirmCancelConfirmedBookingMutation = gql`
  mutation confirmCancellationOfBookingItems(
    $bookingReference: String!
    $paymentLocation: String
    $processRefund: Boolean
    $currency: Currency
  ) {
    confirmCancelBookingItems(
      bookingReference: $bookingReference
      paymentLocation: $paymentLocation
      processRefund: $processRefund
      currency: $currency
    ) {
      cancellable
      totalPriceToBePaid
      agent {
        contractCode
      }
      productFamily
      productFamilyGroup
      notes {
        content
        author
        createdAt
      }
      payments {
        id
        refId
        currency
        currencyRate
        reference
        externalReference
        refundAvailable
        provider
        method
        amount
        availableRefundAmount
        transactionTimestamp
        refundProcessTimestamp
        paymentStatus
        createdRevision
      }
      reference
      status
      displayStatus @client
      arePassengersEditable @client
      allBookingItems @client {
        ...product
        status
      }
      expiryTimestamp
      isInAfterSales
      passengers {
        ...passenger
      }
      customer {
        firstName
        lastName
        email
        companyName
        phoneNumber
        address {
          street
          postalCode
          city
          countryCode
        }
      }
      currency
      productFamilies {
        code
        name
        familyGroup
      }
      totalPrice
      outbound {
        ...leg
      }
      inbound {
        ...leg
      }
      onHold {
        depositAmount
      }
    }
  }

  fragment leg on Leg {
    ...legFields
    addOnLeg {
      ...legFields
    }
  }

  fragment legFields on Leg {
    direction
    hasNewMainProducts
    trainNumber
    id
    classOfService {
      code
      name
    }
    origin {
      name
      uic
      shortCode
      timezone
    }
    destination {
      name
      uic
      shortCode
    }
    timing {
      isoDate
      date
      departs
      arrives
    }
    fees {
      name
      code
      price
      provisional
      currency
      itemRef
    }
    canBeUpgraded
    products {
      ...product
    }
    activeBookingItems @client {
      ...product
    }
    bookingItems @client {
      ...product
      mealCode
      status
    }
    temporarilyCancelledBookingItems @client {
      ...product
      mealCode
      status
    }
    seats {
      coach
      number
      inventoryClass
      itemRef
      passenger {
        id
        type
      }
    }
    meals {
      code
      passenger {
        id
      }
      price
      name
    }
    productSummaries @client {
      name
      passengerType
      code
      total
      quantity
      price
    }
    refundSummaries @client {
      name
      passengerType
      code
      total
      quantity
      price
    }
  }

  fragment passenger on Passenger {
    id
    type
    firstName
    lastName
    email
    phoneNumber
    birthDate
    loyaltyNumber
  }

  fragment product on Product {
    itemRef
    associatedItemRefs
    passengerId
    isAFareAddOn
    price
    tariffDetails {
      tariffCode
    }
    code
    inventoryClass
    name
    cancelled
    provisional
    canBeRebooked
    canBeCancelled
    canBeRefunded
    afterSalesRules {
      active
      validUntil
      price
      type
      currentActive
    }
    passenger {
      ...passenger
    }
  }
`;
